var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKairosWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_3",
    "data-name": "Capa 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.48,852.33v28.8c0,29.19,23.67,52.86,52.86,52.86h361.22l-221.18-378.28-192.9,296.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.34,112.96c-29.19,0-52.86,23.67-52.86,52.86v459.01L432.85,112.96H155.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M868.66,112.96h-285.28l-210.43,325.25,291.84,495.78h31.76v-327.52h124.47v327.52h47.63c29.19,0,52.86-23.67,52.86-52.86V165.82c0-29.19-23.67-52.86-52.86-52.86ZM757.37,549.13c-45.94,0-83.18-37.24-83.18-83.18s37.24-83.18,83.18-83.18,83.18,37.24,83.18,83.18-37.24,83.18-83.18,83.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKairosWhite);
export default __webpack_public_path__ + "static/media/kairos_white.6ae175d992505ae5ddb06087b2ff75d4.svg";
export { ForwardRef as ReactComponent };